import CombineComponents from 'Widgets/CombineComponents/CombineComponents';
import ModelEntityPreselectedVersionIdProvider from './PreselectedVersionContext';
const providers = [ModelEntityPreselectedVersionIdProvider];
const ModelEntityContextProvider = CombineComponents(providers);
export default ModelEntityContextProvider;
